import type { BranchId } from '../../config/constants';

/**
 * Marks an intentional outbound branch switch (e.g. interrupt `reset-branch`)
 * so landing can no-op while the URL still shows the prior branch.
 * Cleared once the URL branch matches answers again.
 */
let pendingBranchSwitch: BranchId | null = null;

export function beginPendingBranchSwitch(branchId: BranchId): void {
  pendingBranchSwitch = branchId;
}

export function getPendingBranchSwitch(): BranchId | null {
  return pendingBranchSwitch;
}

export function clearPendingBranchSwitch(): void {
  pendingBranchSwitch = null;
}
